import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface OutcomeLinkProps {
	victory: boolean
}

export function OutcomeLink(props: OutcomeLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('outcomes', `${props.victory ? 'Victory' : 'Loss'}`)
		}}>
			{props.victory ? 'Victory' : 'Loss'}
		</a>
	)
}
